import { createTheme, ThemeProvider } from '@mui/material';
import { NormalButton } from 'components/atoms/Button';
import React from 'react';
import { MainBody, Overlay } from './styles';

interface IFontMenu {
  hideUI: () => void;
}

const fontArr = ['Silkscreen', 'Roboto', 'Fuzzy Bubbles', 'Roboto Mono'];

const theme = createTheme({
  typography: {
    fontFamily: fontArr.join(','),
  },
});
//Add font body inside main body
const FontMenu = ({ hideUI }: IFontMenu) => {
  return (
    <ThemeProvider theme={theme}>
      <MainBody>
        {fontArr.map((font, index) => {
          return (
            <NormalButton
              key={index}
              sx={{
                width: '200px',
                fontSize: '20px',
                fontFamily: font,
                zIndex: 1,
              }}
              text={font}
            />
          );
        })}
        <Overlay onClick={hideUI} />
      </MainBody>
    </ThemeProvider>
  );
};

export default FontMenu;
